<template>
  <div class="bottom-menu">
    <div class="footer">

      <div v-bind:class="{'foot-box':true, 'active':css == 1}" v-on:click="goHome">
        <img class="default" src="@/assets/images/home.svg" alt="ホーム">
        <img class="hover" src="@/assets/images/home_active.svg" alt="ホーム">
        <p>ホーム</p>
      </div>
      <div v-bind:class="{'foot-box':true, 'active':css == 2}" v-on:click="goCart">
        <img class="default" src="@/assets/images/cart.svg" alt="注文リスト">
        <img class="hover" src="@/assets/images/cart_active.svg" alt="注文リスト">
        <p>注文リスト</p>
      </div>
      <div v-bind:class="{'foot-box':true, 'active':css == 3}" v-on:click="goOrderList">
        <img class="default" src="@/assets/images/order.svg" alt="注文履歴">
        <img class="hover" src="@/assets/images/order_active.svg" alt="注文履歴">
        <p>注文履歴</p>
      </div>
      <div v-bind:class="{'foot-box':true, 'active':css == 4}" v-on:click="goMyPage">
        <img class="default" src="@/assets/images/mypage.svg" alt="マイページ">
        <img class="hover" src="@/assets/images/mypage_active.svg" alt="マイページ">
        <p>マイページ</p>
      </div>
    </div>
  </div>

</template>

<script type="text/ecmascript-6">
  import { ElMessage } from 'element-plus';

  export default {
    data() {
      return {
        css: '1',
        storeId: sessionStorage.getItem("storeId")
      }
    },
    props: {
      cssTitle: String
    },

    mounted() {
      this.css = this.cssTitle;
    },
    methods: {
      goHome () {
        if (sessionStorage.getItem("storeId")) {
          this.$router.push({path: '/goodsCategory'});
        } else {
          this.$router.push({path: '/home'});
        }
      },
      goCart () {
        if (sessionStorage.getItem("storeId")) {
          this.$router.push({path: '/cart'});
        } else {
          ElMessage.closeAll();
          ElMessage.error('店舗を選んでください。');
        }
      },
      goOrderList () {
        this.$router.push({path: '/orderhistory'});
      },
      goMyPage() {
        this.$router.push({path: '/mypage'});
      }
    }
  }
</script>
<style>

  @supports (bottom: env(safe-area-inset-bottom)){
    div.bottom-menu {
      /*padding-bottom: constant(safe-area-inset-bottom, 20px);*/
      padding-bottom: env(safe-area-inset-bottom,0);
      left: env(safe-area-inset-left,0);
      right: env(safe-area-inset-right,0);
      width: calc(100% - ( env(safe-area-inset-left,0) + env(safe-area-inset-right,0) ));
      background-color: #C10230;
      position: fixed;
      bottom: 0;
    }
    .footer{
      position: relative;
    }
  }

</style>
